import { render, staticRenderFns } from "./BackgroundOverlay.vue?vue&type=template&id=20128c9c&scoped=true&"
import script from "./BackgroundOverlay.vue?vue&type=script&lang=js&"
export * from "./BackgroundOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundOverlay.vue?vue&type=style&index=0&id=20128c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20128c9c",
  null
  
)

export default component.exports